import { PanelIndex } from 'common'

export enum ActionTypes {
  PUSH_PANEL = '@@panelList/PUSH_PAGE',
  REMOVE_PANEL = '@@panelList/REMOVE_PANEL',
}

export type State = [PanelIndex, PanelIndex] | [PanelIndex]
